/* 京樽 採用サイト 共通スクリプト（ライブラリ非依存） */
(function () {
  'use strict';

  // ハンバーガーメニュー（1200px 未満）
  var toggle = document.querySelector('[data-r-nav-toggle]');
  var nav = document.getElementById('r-nav');
  if (!toggle || !nav) return;

  var desktop = window.matchMedia('(min-width: 1200px)');

  function setOpen(open) {
    nav.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
    document.documentElement.classList.toggle('r-nav-open', open);
  }

  toggle.addEventListener('click', function () {
    setOpen(!nav.classList.contains('is-open'));
  });

  nav.addEventListener('click', function (event) {
    if (event.target instanceof Element && event.target.closest('a')) setOpen(false);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && nav.classList.contains('is-open')) {
      setOpen(false);
      toggle.focus();
    }
  });

  desktop.addEventListener('change', function (event) {
    if (event.matches) setOpen(false);
  });
})();
